export default {"applyDate":"2019-12-28T07:58:49.353Z","applyOrgId":"2c8c4fb1af09465888fbf01cf425ade9","applyUserName":"1212","applyNum":"1212","remark":"1212"}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/operate/grant/queryOperateGrantInfo.js